import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Loader from 'components/Common/Loader'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 678px;
  gap: 16px;
`

const LoaderText = styled.div`
  font: var(--typography-16-24-semibold);
  color: var(--color-sw-60);
`
// Компонент используется и в Common/Modals/RecognizeWine
const LoadingRecognition = () => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <Loader color='#3B42A5' size='40px' />
      <LoaderText>
        {t('capturedWines.dialog.updateImages.wineRecognition')}
      </LoaderText>
    </Wrapper>
  )
}

export default LoadingRecognition
